// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__im27y","subheader":"ReorderModal_subheader__1Xr5n","listWrap":"ReorderModal_listWrap__3b81G"};